import { CForm } from "@coreui/react"
import ImageContainer from "../components/imageContainer"
import TopContext from "../components/topContext"
import { useTranslation } from "react-i18next"
import SendEmail from "./sendEmail"
import CustomValuesHookTS from "../../../../Hooks/CustomValuesHookTS"

const ChangePassword = () => {
   const { t, i18n } = useTranslation()
   const [cpStates, setCPStates] = CustomValuesHookTS<{ displayPage: string }>({ displayPage: "sendEmail" })

   return (
      <div className={`d-flex flex-row justify-content-between auth-form `}>
         <div className='section-right' >
            <TopContext />
            <div className='d-flex flex-row justify-content-center' >
               <div className='login-section login-form'>
                  <SendEmail setState={setCPStates} />
                  <div className='Copywriter d-flex flex-row justify-content-center' style={{ direction: 'ltr' }}>
                     <p>{t('COPY_WRITE')}</p>
                  </div>
               </div>
            </div>
         </div>
         <ImageContainer />
      </div>
   )
}

export default ChangePassword
